import { useLegacyEntityChanges } from 'src/components/legacy/hooks/use-legacy-entity-changes';
import { useLegacyOpenModalByHash } from 'src/components/legacy/hooks/use-legacy-open-modal-by-hash';

export const useLegacyInterop = () => {
  useLegacyOpenModalByHash();
  useLegacyEntityChanges();
};
